if (!customElements.get('plp-size-bar')) {
  const PROMPT_MS = 2000;

  class PlpSizeBar extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-size-select]');
      this.labelEl = this.querySelector('[data-size-label]');
      this.defaultLabel = this.dataset.defaultLabel ?? '';
      this.promptLabel = this.dataset.promptLabel ?? '';
      this.promptTimer = null;

      this.handleChange = this.handleChange.bind(this);
      this.handleRequest = this.handleRequest.bind(this);
      this.clearAttention = this.clearAttention.bind(this);
      this.endPrompt = this.endPrompt.bind(this);

      this.select?.addEventListener('change', this.handleChange);
      document.addEventListener('theme:plp-size:requested', this.handleRequest);
      this.addEventListener('animationend', this.clearAttention);
    }

    disconnectedCallback() {
      this.select?.removeEventListener('change', this.handleChange);
      document.removeEventListener('theme:plp-size:requested', this.handleRequest);
      this.removeEventListener('animationend', this.clearAttention);
      clearTimeout(this.promptTimer);
    }

    handleChange() {
      this.endPrompt();

      document.dispatchEvent(
        new CustomEvent('theme:plp-size:changed', {
          detail: { size: this.select.value },
          bubbles: true,
        })
      );
    }

    /* A band tried to add to cart before a size was picked. */
    handleRequest() {
      clearTimeout(this.promptTimer);

      this.classList.add('is-prompt', 'is-attention');
      this.setLabel(this.promptLabel);
      this.select?.focus();

      this.promptTimer = setTimeout(this.endPrompt, PROMPT_MS);
    }

    endPrompt() {
      clearTimeout(this.promptTimer);
      this.promptTimer = null;
      this.classList.remove('is-prompt');
      this.setLabel(this.selectedLabel());
    }

    /* The label for the current selection, or the resting option name. */
    selectedLabel() {
      if (!this.select?.value) return this.defaultLabel;

      const option = this.select.options[this.select.selectedIndex];
      return option?.dataset.label ?? option?.textContent.trim() ?? this.defaultLabel;
    }

    clearAttention() {
      this.classList.remove('is-attention');
    }

    setLabel(text) {
      if (this.labelEl) this.labelEl.textContent = text;
    }
  }

  customElements.define('plp-size-bar', PlpSizeBar);
}
